import { DrawerBody as ChakraDrawerBody } from '@chakra-ui/react';

export const DrawerBody = ({ children, ...props }) => (
  <ChakraDrawerBody {...props} p={0} overflowX="hidden">
    {children}
  </ChakraDrawerBody>
);
